import { LoadState } from '@ally/use-data-domain'
import { QueryStatus } from '@tanstack/react-query'

export function normalizeQueryStatus(status: QueryStatus): LoadState {
  const statusMap = {
    success: LoadState.LOADED,
    error: LoadState.FAILED,
    loading: LoadState.LOADING,
  }[status]

  return statusMap
}

export function pluralize(word: string, count: number): string {
  return typeof count !== 'number' || count <= 1 ? word : `${word}s`
}

export function diff(...nums: any): number {
  const numArr = [...nums]
  return numArr.reduce((acc, cur) => {
    return Math.max(0, acc - cur) // return 0 if negative diff
  })
}

export function mergeLoadStates(...loadStates: any): LoadState {
  const multiLoadState = [...loadStates]
  if (multiLoadState.includes(LoadState.FAILED)) {
    return LoadState.FAILED
  }
  if (multiLoadState.includes(LoadState.LOADING)) {
    return LoadState.LOADING
  }
  if (multiLoadState.includes(LoadState.LOADED)) {
    return LoadState.LOADED
  }
  return LoadState.FAILED
}
